import { render, staticRenderFns } from "./ItemBase.vue?vue&type=template&id=6a72af41"
import script from "./ItemBase.vue?vue&type=script&lang=js"
export * from "./ItemBase.vue?vue&type=script&lang=js"
import style0 from "./ItemBase.vue?vue&type=style&index=0&id=6a72af41&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports